// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"ConfirmationPop_ConfirmationPop__+x1PK","modalBody":"ConfirmationPop_modalBody__BMTOp"};